import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// oxlint-disable-next-line no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IssueNavigatorPinRedirectEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const issueNavigatorPinRedirectEntrypoint: EntryPoint<
	IssueNavigatorPinRedirectEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<IssueNavigatorPinRedirectEntrypointComponent>(
		/* webpackChunkName: "async-project-issue-navigator-pin-redirect-entrypoint" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
